<template lang="pug">
v-card.custom-card(outlined)
  v-card-text.custom-card-body
    .d-flex.align-center.justify-space-between.gap-2
      .info-cliente-col
        .info-empresa-nome.text-truncate {{ info.nome }}
        .info-empresa-detalhes
          span.info-persona-texto.text-truncate {{ info.persona }}
          v-tooltip(v-if="outrasPersonas.length > 0", bottom)
            template(v-slot:activator="{ on, attrs }")
              v-chip.info-persona-mais(v-bind="attrs", v-on="on", x-small, label) +{{ outrasPersonas.length }}
            div(v-for="(nome, idx) in [info.persona, ...outrasPersonas]", :key="idx") {{ nome }}
      .d-flex.align-center.gap-2.info-actions
        v-tooltip(v-if="mostrarLogs", bottom)
          template(v-slot:activator="{ on, attrs }")
            v-btn.btn-action.btn-action--icone.text-none(
              v-bind="attrs",
              v-on="on",
              small,
              outlined,
              :disabled="!hasCliente",
              @click="$emit('abrir-logs')"
            )
              v-icon.px-0.mx-0(small) mdi-history
          span {{ tooltipLogs }}
        v-tooltip(v-if="isGerente && mostrarSincronizar", bottom)
          template(v-slot:activator="{ on, attrs }")
            v-btn.btn-action.btn-action--icone.text-none(
              v-bind="attrs",
              v-on="on",
              small,
              outlined,
              :disabled="sincronizarDesabilitado || !hasCliente",
              @click="$emit('sincronizar')"
            )
              v-icon.px-0.mx-0(small) mdi-database-sync
          span {{ tooltipSincronizar }}
        v-tooltip(bottom)
          template(v-slot:activator="{ on, attrs }")
            v-btn.btn-send.btn-action--icone(
              v-if="isGerente",
              v-bind="attrs",
              v-on="on",
              small,
              color="primary",
              :disabled="!hasCliente || !hasAlteracoesPendentes",
              @click="$emit('salvar')"
            )
              v-icon.px-0.mx-0(small) mdi-content-save
          span {{ tooltipSalvar }}
        v-tooltip(v-if="mostrarForcarEnvio", bottom)
          template(v-slot:activator="{ on, attrs }")
            v-btn.btn-action.btn-action--icone.text-none(
              v-bind="attrs",
              v-on="on",
              small,
              outlined,
              :disabled="forcarEnvioDesabilitado || !hasCliente || hasAlteracoesPendentes",
              @click="$emit('forcar-envio')"
            )
              v-icon.px-0.mx-0(small) mdi-cube-send
          span {{ tooltipForcarEnvio }}
  v-divider
  .modulo-controls.d-flex.custom-card-body
    .d-flex.flex-grow-1(v-if="mostrarModulo", style="flex-basis: 40%")
      v-select.modulo-select.preview-field(
        :label="labelModulo",
        :value="modulo",
        @change="$emit('update:modulo', $event)",
        :items="modulos",
        item-text="text",
        item-value="value",
        :disabled="!hasCliente || hasAlteracoesPendentes",
        outlined,
        dense,
        hide-details
      )
    //- Sem o seletor de módulo, o espaçador preserva a posição do campo ao lado.
    //- O slot permite que a tela use esse espaço (opcional; vazio nas demais telas).
    .d-flex.flex-grow-1.align-center(v-else, style="flex-basis: 40%; min-width: 0")
      slot(name="espaco-esquerdo")
    .d-flex.flex-grow-1.align-center(v-if="isGerente", style="flex-basis: 60%")
      v-select.modo-edicao-select.preview-field.ml-4(
        v-if="mostrarModo",
        :label="labelModo",
        :value="modo",
        @change="$emit('update:modo', $event)",
        :items="modos",
        item-text="text",
        item-value="value",
        :disabled="!hasCliente || hasAlteracoesPendentes",
        outlined,
        dense,
        hide-details,
        style="max-width: 220px"
      )
      v-spacer
      v-btn.btn-action.text-none.ml-3(
        small,
        outlined,
        :disabled="!hasAlteracoesPendentes",
        @click="$emit('cancelar')"
      ) {{ textoCancelar }}
</template>

<script>
export default {
  name: "InfoClienteCard",

  computed: {
    // Demais caracterizações do cliente (a primeira está em info.persona).
    outrasPersonas() {
      return this.info.outrasPersonas || [];
    }
  },

  props: {
    // info: { nome, persona, outrasPersonas?: string[] }
    info: {
      type: Object,
      default: () => ({ nome: "", persona: "", outrasPersonas: [] })
    },
    modulos: {
      type: Array,
      default: () => []
    },
    modulo: {
      type: [String, Number],
      default: null
    },
    modos: {
      type: Array,
      default: () => []
    },
    modo: {
      type: String,
      default: ""
    },
    isGerente: {
      type: Boolean,
      default: false
    },
    // Quando falso, oculta o seletor de módulo e o campo de tipo de
    // manipulação ocupa toda a largura da linha.
    mostrarModulo: {
      type: Boolean,
      default: true
    },
    // Quando falso, oculta o seletor de tipo de manipulação. A linha mantém a
    // altura, preservando o alinhamento com as demais colunas.
    mostrarModo: {
      type: Boolean,
      default: true
    },
    mostrarLogs: {
      type: Boolean,
      default: true
    },
    mostrarForcarEnvio: {
      type: Boolean,
      default: true
    },
    // Botão opcional (somente gerente) entre Logs e Salvar; usado apenas na tela de empresas.
    mostrarSincronizar: {
      type: Boolean,
      default: false
    },
    sincronizarDesabilitado: {
      type: Boolean,
      default: false
    },
    hasCliente: {
      type: Boolean,
      default: false
    },
    hasAlteracoesPendentes: {
      type: Boolean,
      default: false
    },
    forcarEnvioDesabilitado: {
      type: Boolean,
      default: false
    },
    labelModulo: {
      type: String,
      default: "Módulo"
    },
    labelModo: {
      type: String,
      default: "Tipo de manipulação"
    },
    tooltipLogs: {
      type: String,
      default: "Logs de Operações"
    },
    tooltipSincronizar: {
      type: String,
      default: "Sincronizar empresas da base"
    },
    tooltipSalvar: {
      type: String,
      default: "Salvar"
    },
    tooltipForcarEnvio: {
      type: String,
      default: "Forçar envio"
    },
    textoCancelar: {
      type: String,
      default: "Cancelar"
    }
  }
};
</script>

<style scoped>
.custom-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #d9e2ec !important;
  border-radius: 18px 6px 18px 6px !important;
  box-shadow: 0 2px 8px rgba(15, 42, 77, 0.08) !important;
}

/* Proporção entre as duas linhas do card */
.custom-card-body {
  flex: 0 0 45%;
  display: flex;
  align-items: center;
  padding: 0 18px !important;
}

.custom-card-body > .d-flex {
  width: 100%;
}

.modulo-controls {
  flex: 0 0 55%;
  align-items: center;
}

.gap-2 {
  gap: 8px;
}

.btn-action {
  height: 30px !important;
  min-width: 0 !important;
  padding: 0 12px !important;
  font-size: 12px !important;
  letter-spacing: 0.01em !important;
  border: 1px solid #d0d7de !important;
  color: #57606a !important;
  background-color: #ffffff !important;
  font-weight: 500 !important;
  border-radius: 6px !important;
}

.text-none {
  text-transform: none !important;
}

.modulo-select {
  max-width: 250px;
}

/* Harmoniza v-select e v-text-field outlined com .btn-action */
.preview-field {
  border-radius: 6px !important;
  background-color: #fff;
}

.preview-field.v-input--is-focused .v-input__slot {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 1px rgba(25, 118, 210, 0.15);
}

.preview-field .v-input__slot:hover {
  border-color: #b1bac4;
}

.preview-field .v-input__slot,
.preview-field .v-text-field__slot input,
.preview-field .v-select__selection {
  font-size: 13px;
  color: #2c3e50;
  font-weight: 500;
  min-height: 36px !important;
}

.preview-field .v-input__slot {
  min-height: 36px !important;
}

.preview-field .v-input__prepend-inner .v-icon,
.preview-field .v-input__append-inner .v-icon {
  color: #57606a;
  font-size: 18px;
}

.preview-field .v-label {
  color: #8a94a3;
  font-size: 13px;
}

.info-empresa-nome {
  font-size: 14px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 2px;
}

.info-cliente-col {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.info-actions {
  flex-shrink: 0;
}

.info-empresa-detalhes {
  display: flex;
  align-items: center;
  min-width: 0;
  font-size: 14px;
  color: #777;
  white-space: nowrap;
}

.info-persona-texto {
  min-width: 0;
}

/* Contador das demais caracterizações, ao lado do texto da primeira */
.info-persona-mais {
  flex-shrink: 0;
  margin-left: 8px;
  height: 18px !important;
  padding: 0 6px !important;
  font-size: 11px !important;
  font-weight: 700;
  color: #1565c0 !important;
  background-color: #e3f2fd !important;
  border: 1px solid #bbdefb;
  border-radius: 9px !important;
  cursor: default;
}

.btn-action--icone {
  width: 30px !important;
  min-width: 30px !important;
  height: 30px !important;
  padding: 0 !important;
}

.btn-send {
  background-color: #1976d2;
  color: #fff;
  border-radius: 6px !important;
}
</style>
